"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapper = exports.reactPlayerWrapper = exports.playButton = exports.overlay = exports.buttonWrapper = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var wrapper = exports.wrapper = {
  name: "79elbk",
  styles: "position:relative;"
};
var fixedAspectRatio = padding => /*#__PURE__*/(0, _core.css)("width:100%;height:initial;display:inline-block;&::after{display:block;content:'';padding-top:", padding, ";}> div{position:absolute;top:0;right:0;width:100%;height:100%;}");
var AspectRatios = {
  'sixteen-nine': fixedAspectRatio('56.25%'),
  'four-three': fixedAspectRatio('75%'),
  'full-height': {
    name: "10klw3m",
    styles: "height:100%;"
  },
  default: /*#__PURE__*/(0, _core.css)("height:300px;", (0, _feBrary.media)('>=tablet'), "{height:500px;}", (0, _feBrary.media)('>=lrg-desktop'), "{height:600px;}")
};
var reactPlayerWrapper = aspectRatio => AspectRatios[aspectRatio] || AspectRatios.default;
exports.reactPlayerWrapper = reactPlayerWrapper;
var playButton = hidePlayButton => /*#__PURE__*/(0, _core.css)("position:absolute;top:50%;left:50%;width:100px;height:100px;transform:translate(-50%,-50%);border-radius:100%;background:rgba(0,0,0,0.3);cursor:pointer;z-index:2;", hidePlayButton && "display: none;\n  ");
exports.playButton = playButton;
var overlay = hideOverlay => /*#__PURE__*/(0, _core.css)("position:absolute;width:100%;height:100%;background-repeat:no-repeat;background-position:center;background-size:cover;z-index:1;", hideOverlay && "display: none;\n  ");
exports.overlay = overlay;
var buttonWrapper = exports.buttonWrapper = /*#__PURE__*/(0, _core.css)("::before{font-family:'Domain',sans-serif;speak:none;font-style:normal;font-weight:normal;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;display:inline-block;margin-top:28px;margin-left:31px;color:", _feBrary.variables.colour.white, ";font-size:48px;content:'\\e634';}");